module.exports = __webpack_public_path__ + "img/loanicon.d01cb2bf.svg";